// extracted by css-extract-rspack-plugin
export default {"root":"PP11Dh_0vUcVTLT2","image":"iVnADk7LLsMZGlP9","content":"f_f9Z1FzlK0g0uGm","header":"AC5zCmQKxN8W32z9","description":"eGJfzF0Xl0wQzHl9"};